"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HashMap = void 0;
var object_hash_1 = __importDefault(require("object-hash"));
var HashMap = /** @class */ (function () {
    function HashMap(entries) {
        var _this = this;
        this.keyMap = new Map();
        this.valueMap = new Map();
        if (entries) {
            entries.forEach(function (_a) {
                var _b = __read(_a, 2), k = _b[0], v = _b[1];
                var sk = _this.toKey(k);
                _this.keyMap.set(sk, k);
                _this.valueMap.set(sk, v);
            });
        }
    }
    HashMap.prototype.clear = function () {
        this.keyMap.clear();
        this.valueMap.clear();
    };
    HashMap.prototype.delete = function (key) {
        var sk = this.toKey(key);
        this.keyMap.delete(sk);
        return this.valueMap.delete(sk);
    };
    HashMap.prototype.forEach = function (callbackfn, thisArg) {
        var _this = this;
        this.keyMap.forEach(function (key, sk) { return callbackfn(_this.valueMap.get(sk), key, _this); }, thisArg);
    };
    HashMap.prototype.get = function (key) {
        return this.valueMap.get(this.toKey(key));
    };
    HashMap.prototype.has = function (key) {
        return this.valueMap.has(this.toKey(key));
    };
    HashMap.prototype.values = function () {
        return this.valueMap.values();
    };
    Object.defineProperty(HashMap.prototype, "size", {
        get: function () {
            return this.keyMap.size;
        },
        enumerable: false,
        configurable: true
    });
    HashMap.prototype[Symbol.iterator] = function () {
        return this.entries();
    };
    HashMap.prototype.entries = function () {
        var _a, _b, _c, sk, key, e_1_1;
        var e_1, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 5, 6, 7]);
                    _a = __values(this.keyMap.entries()), _b = _a.next();
                    _e.label = 1;
                case 1:
                    if (!!_b.done) return [3 /*break*/, 4];
                    _c = __read(_b.value, 2), sk = _c[0], key = _c[1];
                    return [4 /*yield*/, [key, this.valueMap.get(sk)]];
                case 2:
                    _e.sent();
                    _e.label = 3;
                case 3:
                    _b = _a.next();
                    return [3 /*break*/, 1];
                case 4: return [3 /*break*/, 7];
                case 5:
                    e_1_1 = _e.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 7];
                case 6:
                    try {
                        if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    };
    HashMap.prototype.keys = function () {
        return this.keyMap.values();
    };
    Object.defineProperty(HashMap.prototype, Symbol.toStringTag, {
        get: function () {
            return "HashMap";
        },
        enumerable: false,
        configurable: true
    });
    HashMap.prototype.set = function (key, value) {
        var sk = this.toKey(key);
        this.keyMap.set(sk, key);
        this.valueMap.set(sk, value);
        return this;
    };
    HashMap.prototype.toKey = function (key) {
        if (key === null) {
            return "null";
        }
        switch (typeof key) {
            case "undefined":
                return "undefined";
            case "string":
                return key;
            case "number":
                return key.toString();
            default:
                return (0, object_hash_1.default)(key);
        }
    };
    return HashMap;
}());
exports.HashMap = HashMap;
